import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { BookOpen, Clock } from "lucide-react";
import BlogCover from "@/components/BlogCover";

const CATS = ["All", "Macro & Policy", "Technical Analysis", "IPO Reviews", "Company Spotlights", "Option Strategies", "Real Estate", "Crypto", "Commodities", "Economy"];

function readTime(content) {
  const words = (content || "").split(/\s+/).length;
  return Math.max(1, Math.round(words / 220));
}

export default function Blogs() {
  const [cat, setCat] = useState("All");
  const { data } = useQuery({
    queryKey: ["blogs", cat],
    queryFn: async () => (await api.get(`/blogs?category=${encodeURIComponent(cat)}`)).data,
  });
  const items = data?.data || [];
  return (
    <div className="px-4 sm:px-6 lg:px-10 py-8 max-w-[1200px] mx-auto">
      <div className="ns-eyebrow mb-2">Editorial</div>
      <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-[#1A1A1A] mb-2">Market Insights</h1>
      <p className="text-[#6B6C6F] mb-6 max-w-2xl text-sm">Deep dives from our desk — technical setups, macro views, IPO research, and options playbooks.</p>

      <div className="flex flex-wrap gap-2 mb-8">
        {CATS.map(c => (
          <button key={c} onClick={() => setCat(c)}
            className={`text-xs px-3 py-1.5 rounded-full font-semibold border transition-colors ${cat === c ? "bg-[#D91E2A] text-white border-[#D91E2A]" : "bg-white text-[#3A3B3E] border-[#E2DDD3] hover:border-[#D91E2A]/40"}`}
            data-testid={`blog-cat-${c.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
          >{c}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(b => (
          <Link to={`/blogs/${b.slug}`} key={b.id} className="group ns-card overflow-hidden hover:border-[#D91E2A]/40 transition-colors" data-testid={`blog-card-${b.slug}`}>
            <div className="aspect-video overflow-hidden">
              <div className="w-full h-full transition-transform duration-500 group-hover:scale-105">
                <BlogCover src={b.cover_image} title={b.title} category={b.category} />
              </div>
            </div>
            <div className="p-5">
              <div className="ns-eyebrow mb-2">{(b.category || "Research").toUpperCase()}</div>
              <h3 className="font-heading font-bold text-lg text-[#1A1A1A] leading-snug group-hover:text-[#D91E2A]">{b.title}</h3>
              <p className="text-xs text-[#6B6C6F] mt-2 line-clamp-2">{b.excerpt}</p>
              <div className="flex items-center justify-between mt-4 text-[11px] text-[#8C8D90] font-mono-fin">
                <span>{b.author}</span>
                <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {readTime(b.content)} min</span>
              </div>
            </div>
          </Link>
        ))}
        {items.length === 0 && <div className="col-span-full text-[#8C8D90] font-mono-fin py-10 text-center">No posts yet.</div>}
      </div>
    </div>
  );
}
